import { createAction, createSlice } from "@reduxjs/toolkit";

const getHighestRatedCoursesSlice = createSlice({
  name: "getHighestRatedCourses",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data } = action.payload;
      state.data = data.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getHighestRatedCoursesSlice;
const getHighestRatedCoursesAction = createAction(name);

export {
  getHighestRatedCoursesAction,
  actions as getHighestRatedCoursesActions,
  reducer as getHighestRatedCoursesReducer,
};
